import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-sans font-bold transition-all focus:outline-none focus:ring-2 focus:ring-bloom-green-deep focus:ring-offset-2 uppercase tracking-[0.08em]",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-bloom-green-mid",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-bloom-cream/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-bloom-green-deep border-bloom-border",
        bloom: "border-transparent bg-bloom-gold/10 text-bloom-gold-dark hover:bg-bloom-gold/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
